<template>
  <CCard>
    <CCardHeader>
      <CIcon name="cil-calendar"/> Ημερολόγιο Υποθέσεων
    </CCardHeader>
    <CCardBody>
      <calendar-view
        id="calendar"
        :events="computedEvents"
        :show-date="showDate"
        :displayPeriodUom="displayPeriod"
        currentPeriodLabel="icons"
        :class="themeClasses"
        @click-event="onClickEvent"
        @show-date-change="setShowDate"
        ref="calendarView"
      >
        <calendar-view-header
					slot="header"
					slot-scope="{ headerProps }"
					:header-props="headerProps"
					@input="setShowDate"
				/>
      </calendar-view>
    </CCardBody>
    <CCardFooter>
      <CForm inline>
        <CSelect
          :options="['year', 'month', 'week']"
          :value.sync="displayPeriod"
          label="View"
          add-wrapper-classes="ml-2"
        />
        <div class="form-group ml-2 mr-2">
            <label>Κατάσταση</label>
            <div class="ml-2">
              <multiselect 
                v-model="status" 
                id="status" 
                :options="statusOptions"
                label="label"
                track-by="label">
              </multiselect>
            </div>
        </div>
        <CSelect
          :options="inspectors"
          :value.sync="inspector"
          label="Επιθεωρητής"
          add-wrapper-classes="ml-2 mr-2"
        />
        <div class="form-group ml-2">
            <label>Υπηρεσίες</label>
            <div class="ml-2">
              <multiselect 
                v-model="selectedServices" 
                id="services" 
                multiple
                :options="services"
                label="label"
                track-by="label">
              </multiselect>
            </div>
        </div>
      </CForm>
    </CCardFooter>
  </CCard>
</template>

<script>
  import { 
    CalendarView, 
    CalendarViewHeader, 
    CalendarMathMixin 
  } from 'vue-simple-calendar'
  // import CalendarMathMixin from 'vue-simple-calendar/dist/calendar-math-mixin.js'
  // The next two lines are processed by webpack. If you're using the component without webpack compilation,
  // you should just create <link> elements for these as you would normally for CSS files. Both of these
  // CSS files are optional, you can create your own theme if you prefer.
  import 'vue-simple-calendar/static/css/default.css'
  import 'vue-simple-calendar/static/css/holidays-us.css'
  import axios from 'axios'
  import moment from 'moment'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import Multiselect from 'vue-multiselect'

  const currDate = new Date();
  export default {
    name: 'CasesCalendar',
    mixins: [CalendarMathMixin],

    props: {
      cases: {
        type: Array,
        default: () => []
      }
    },
    data: function () {
      return {
        message: '',
        showDate: currDate,
        displayPeriod: 'month',
        useDefaultTheme: true,
        useHolidayTheme: true,
        statusOptions: [],
        status: '',
        items: this.cases,
        inspectors: [],
        inspector: '0',
        services: [],
        selectedServices: []
      }
    },
    components: {
      CalendarView,
      CalendarViewHeader,
      Multiselect
    },
    computed: {
      themeClasses() {
        return {
          'theme-default': this.useDefaultTheme,
        }
      },
      computedEvents() {
        let results = this.events;
        if (this.status) {
          results = results.filter((item) => item.status_id == this.status.value);
        }

        if (this.inspector != '0') {
          results = results.filter((item) => item.inspectors.find((insp) => insp.id == this.inspector));
        }

        if (this.selectedServices.length) {
          let serviceIds = this.selectedServices.map(item => item.value);
          results = results.filter((item) => serviceIds.includes(item.service_id));
        }

        return results;
      },

      events(){
        let events = [];
        if(this.items !== null){
          this.items.forEach((item) => {
            let formattedEvents = item.next_visit.map((date, index) => {
              return {
                id: item.id + '-' + index,
                title: item.client.company,
                startDate: moment(date, 'YYYY-MM-DD'),
                endDate: moment(date, 'YYYY-MM-DD'),
                classes: item.status.class,
                status_id: item.status_id,
                inspectors: item.inspectors,
                service_id: item.service_id
              }
            });
            events = events.concat(formattedEvents);
          });
        }
        return events;
      }
    },
    methods: {
      setShowDate(d) {
        this.showDate = d;
      },
      onClickEvent(e) {
        const caseLink = this.caseLink( e.id.split('-')[0] );
        this.$router.push({path: caseLink});
        this.message = `You clicked: ${e.id.split('-')[0]}`
      },
      caseLink (id) {
        return `/cases/${id.toString()}`
      },
      getStatuses (){
        let self = this;
        axios.get('/api/cases/casesCalendar?token=' + localStorage.getItem("api_token"))
        .then(function (response) {
          self.statusOptions = response.data.statuses.map((item) => {
            return {
              label: item.name,
              value: item.id
            }
          });
          self.items = response.data.cases;
          let defaultValue = {
            label: 'Επιλέξτε επιθεωρητή',
            value: '0',
          };
          self.inspectors = response.data.inspectors.map((item) => {
            return {
              label: item.name,
              value: item.id
            }
          });
          self.services = response.data.services.map((item) => {
            return {
              label: item.name,
              value: item.id
            }
          });
          self.inspectors.unshift(defaultValue);
          self.loading = false;
        }).catch(function (error) {
          self.loading = false;
          console.log(error);
        });
      },
    },
    mounted: function(){
      this.getStatuses();
    }
  }
</script>

<style lang="scss">
  @import '../../assets/scss/style';
  #calendar {
    color: $body-color;
    height: 63vh;
    margin-left: auto;
    margin-right: auto;
  }
  .theme-default .cv-event {
    background-color: #C8CED3;
    border-color: $table-border-color;
    color: $body-color;
  }
  .theme-default .cv-event.success {
    background-color: $success;
    border-color: lighten($success, 5%);
  }
  .theme-default .cv-event.danger {
    background-color: $danger;
  }
  .theme-default .cv-event.primary {
    background-color: #20A8D8;
  }
  .theme-default .cv-event.orange {
    background-color: #F8CB00;
    border-color: lighten(#F8CB00, 5%);
  }
  .theme-default .cv-day.today {
    background-color: $gray-300;
  }
  .theme-default .cv-day.today > .cv-day-number {
    background-color: #20A8D8;
    border-radius: 50%;
    position: absolute;
    left: 0;
  }
  .theme-default .cv-day.past {
     background-color: $body-bg;
  }
  .theme-default .cv-day.outsideOfMonth {
     background-color: $body-bg;
  }
  .theme-default .cv-weeks,
  .theme-default .cv-day {
    border-color: $table-border-color;
  }
  .theme-default .cv-header,
  .theme-default .cv-header-days,
  .theme-default .cv-header-day {
    background-color: #E4E5E6;
    border-color: $table-border-color;
    border-style: solid;
  }
  .theme-default .cv-header-nav > button {
    color: $body-color;
    background-color: $input-bg;
    border-color: $input-border-color;
  }
  .theme-default .cv-day.draghover {
    box-shadow: inset 0 0 0.2em 0.2em #321FDB;
  }
  .cv-event.span1 {
    cursor: pointer;
  }
</style>